/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileUnknown = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V22H4zm2 2v16h12V9h-5V4zm9 1.414V7h1.586z" />
        <path d="m11.17 15.861-.174-1.78.75-.359c.86-.42 1.291-.923 1.291-1.509 0-.333-.105-.586-.315-.76-.202-.174-.495-.26-.879-.26-.232 0-.5.036-.803.108a6.545 6.545 0 0 0-.923.304V10.52c.275-.123.582-.22.923-.293.34-.08.658-.12.955-.12 1.535 0 2.302.663 2.302 1.988 0 .492-.167.944-.5 1.357-.325.412-.832.782-1.52 1.107l-.14 1.303zM10.888 18v-1.357h1.541V18z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileUnknown as FileUnknown };
